const QCHECK = [
  {
    title: "Certificate of Registration",
    type: "checkLink"
  },
  {
    text: "Memorandum/Article of Association/Company Constitution",
    type: "checkLink"
  },
  {
    text: "Bank / Remittance License / E-money / Other equivalent approval",
    type: "checkLink",
  },
  {
    title: "Latest registrar information",
    type: "checkLink"
  },
  {
    text: "Latest AML/CFT Policy",
    type:"checkLink",
  },
  {
    title: "Identification Proof of Ultimate Beneficial Owner (UBO)",
    type:"checkLink" 
  },
  {
    title: "Proof of address of Ultimate Beneficial Owner (UBO) (not more than 3 months old)",
    type:"checkLink" 
  },
  {
    title: "Identification Proof of Directors",
    type:"checkLink" 
  },
    {
    title: "Proof of address of Directors (not more than 3 months old)",
    type:"checkLink" 
  },
  {
    title:"Executive Directors / Authorised signatory (not more than 3 months old)",
    type: "checkLink",
  },
  {
    text: "Valid PCI DSS AOC, If available",
    type: "checkLink"
  },
  {
    text: "Latest Audited Financial Statement / 6 months Bank Statement",
    type: "checkLink"
  },
  {
    text: "TRAXX.ID Screening report of Company with ongoing Screening (OGS)",
    type:"checkLink"
  },
  {
    title: "TRAXX.ID document and biometric verification",
    subtitle: "Applicable to all directors and UBO",
    type: "checkLink"
  },
  {
    title: "Live video verification",
    subtitle: "If 14 reply is 'No', proceed with live video verification",
    type: "checkLink",
  },
  {
    text: "TRAXX.ID Screening report of all directors and UBOs with Ongoing Screening (OGS)",
    type: "checkLink"
  }
];

export { QCHECK };
